import { createFileRoute } from '@tanstack/react-router';

import { validatePaymentSearch } from '@/features/payment-retry/services/stripe-return.service';
import { PaymentPage } from '@/pages/payment.page';

export const Route = createFileRoute('/_authenticated/payment')({
  validateSearch: validatePaymentSearch,
  component: PaymentPage,
});
